import React from 'react';
import { Link } from 'react-router-dom';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../../../config/locale';
import ItineraryFoodInvoicePropTypes from '../proptypes/ItineraryFoodInvoiceProptypes';
import { ITINERARY_FOR_COUNTER_PATH } from '../../../../../config/paths';
import EnumStatus from '../../../../common/EnumStatus';
import Table from '../../../../common/Table';
import { FOOD_PUBLIC_TYPE } from '../../../../../config/constants';

const ItineraryFoodInvoiceBasicInformationResource = ({
  id,
  supplierBusinessTaxId,
  supplierBusinessName,
  documentSeries,
  documentCode,
  amount,
  issueDate,
  expirationDate,
  periodStartDate,
  periodEndDate,
  accountingDeliveredDate,
  createDate,
  itinerarySupplierFoodDetailList,
  summaryNumber,
  description,
}) => (
  <>
    <ResourceProperty label="ID:">{id || '-'}</ResourceProperty>

    <ResourceProperty label="Proveedor:">
      {supplierBusinessName || '-'}
    </ResourceProperty>

    <ResourceProperty label="RUC:">
      {supplierBusinessTaxId || '-'}
    </ResourceProperty>

    <ResourceProperty label="Serie documento:">
      {documentSeries || '-'}
    </ResourceProperty>

    <ResourceProperty label="Correlativo documento:">
      {documentCode || '-'}
    </ResourceProperty>

    <ResourceProperty label="N° Resumen:">
      {summaryNumber || '-'}
    </ResourceProperty>

    <ResourceProperty label="Descripción:">
      {description || '-'}
    </ResourceProperty>
    <ResourceProperty label="Monto Total:">
      {amount.toFixed(2) || '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha de Emisión:">
      {issueDate
        ? tzNormalizeDate({ date: issueDate, format: DATE_FORMAT })
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha de Expiración:">
      {expirationDate
        ? tzNormalizeDate({ date: expirationDate, format: DATE_FORMAT })
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha de Entrega a Contabilidad:">
      {accountingDeliveredDate
        ? tzNormalizeDate({
            date: accountingDeliveredDate,
            format: DATE_FORMAT,
          })
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Periodo desde:">
      {periodStartDate
        ? tzNormalizeDate({ date: periodStartDate, format: DATE_FORMAT })
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Periodo hasta:">
      {periodEndDate
        ? tzNormalizeDate({ date: periodEndDate, format: DATE_FORMAT })
        : '-'}
    </ResourceProperty>

    <ResourceProperty label="Fecha de creación:">
      {createDate
        ? tzNormalizeDate({ date: createDate, format: DATE_TIME_FORMAT })
        : '-'}
    </ResourceProperty>

    <h3>Detalle de la Factura</h3>

    {itinerarySupplierFoodDetailList &&
    itinerarySupplierFoodDetailList.length > 0 ? (
      <Table
        columns={[
          {
            Header: 'ID Itinerario',
            accessor: 'itineraryId',
            className: 'text-center',
            Cell: (row) => (
              <Link
                to={`${ITINERARY_FOR_COUNTER_PATH}/${row.value}`}
                target="_blank"
              >
                {row.value}
              </Link>
            ),
          },
          {
            Header: 'Origen',
            accessor: 'originLocationName',
            className: 'text-center',
          },
          {
            Header: 'Destino',
            accessor: 'destinationLocationName',
            className: 'text-center',
          },
          {
            Header: 'Bus',
            accessor: 'registeredBus.companyBusId',
            className: 'text-center',
          },
          {
            Header: 'Alimento',
            accessor: 'foodName',
            className: 'text-center',
          },
          {
            Header: 'Público',
            accessor: 'publicType',
            className: 'text-center',
            Cell: (row) => (
              <EnumStatus enumObject={FOOD_PUBLIC_TYPE} enumValue={row.value} />
            ),
          },
          {
            Header: 'Cantidad',
            accessor: 'totalQuantity',
            className: 'text-center',
          },
          {
            Header: 'Costo',
            accessor: 'totalAmount',
            className: 'text-center',
          },
        ]}
        data={itinerarySupplierFoodDetailList}
        manual={false}
        defaultPageSize={
          itinerarySupplierFoodDetailList.length > 10
            ? 10
            : itinerarySupplierFoodDetailList.length
        }
        showPagination={itinerarySupplierFoodDetailList.length > 10}
      />
    ) : (
      <div className="alert alert-info">Sin detalle de alimentación</div>
    )}
  </>
);

ItineraryFoodInvoiceBasicInformationResource.propTypes =
  ItineraryFoodInvoicePropTypes;

ItineraryFoodInvoiceBasicInformationResource.defaultProps = {
  itinerarySupplierFoodDetailList: [],
  createDate: null,
};

export default ItineraryFoodInvoiceBasicInformationResource;
